
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import type { PropType } from 'vue';
import { Book } from './types';
import StatisticsLicenseSale from './StatisticsLicenseSale.vue';
import Accordion from '@/components/ui/accordion/Accordion.vue';

@Component({
  components: { Accordion, StatisticsLicenseSale }
})
export default class StatisticsLicenseBook extends Vue {
  @Prop({ type: Object as PropType<Book>, default: () => {} })
  book!: Book;

  accordionExpanded: boolean = false;

  renderContent() {
    this.accordionExpanded = !this.accordionExpanded;
  }
}
